import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { TimelineScatterplotWidget } from '../../widgets';

class ScatterplotTester extends Component {

  render() {

    const { src } = this.props;

    console.dir(this.props);

    return (
      <div className="dashboard">
        <TimelineScatterplotWidget input={src} />
      </div>
    );
  }
}


ScatterplotTester.defaultProps = null;

ScatterplotTester.propTypes = { src: PropTypes.shape(TimelineScatterplotWidget.propTypes) };

export default ScatterplotTester;
